import styled from 'styled-components';
import {colorPalette} from '../../Config/colorConfig.js'
import { animated } from 'react-spring'

//RWD: 1300 & 1000
//Card general style
const Content = styled(animated.div)`
    //width, height在useSpring設
    cursor:'pointer';
    position: absolute;
    top:5%;
    right:15%;
    background-color:rgba(255, 255, 255, 0.90);
    box-shadow: 0px 10px 30px -5px rgba(0, 0, 0, 0.5);
    overflow-y:auto;
    overflow-x:hidden;
    z-index: 400;
    &::-webkit-scrollbar-track{
        background-color: ${colorPalette.myYellow};
    }
    &::-webkit-scrollbar{
        height:3vw;
        max-height:12px;
        width:3vw;
        max-width: 12px;
        background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb{
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #555;
    }
    &::-webkit-scrollbar-corner { background: #F5F5F5; }
`

const TitleWrapper = styled.div`
    position:relative;
    width:100%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    background-color:${colorPalette.myBlue};
`

const TitleLogoImg = styled.div`
    position:absolute;
    width:90%;
    height:100%;
    left:0px;
    background-size: contain;
    background-repeat: no-repeat;
    @media (max-width: 768px) {
        display:none;
    }
`

const Title = styled.div`
    position:relative;
    display:flex;
    color:#FFF;
    padding:5px;
    font-size:3rem;
    font-weight: ${props => props.langCh ? 700 : 900};
    letter-spacing: 0.05em;
    @media (max-width: 1300px) {
        font-size:2rem;
    }
    @media (max-width: 1000px) {
        font-size:1.5rem;
    }
    @media (max-width: 768px) {
        font-size: ${props => props.smallFont ? '1rem' : '1.2rem'};
    }
`

const YellowWrapper = styled.div`
    position:relative;
    display:flex;
    width:100%;
`

const YellowImg = styled.div`
    position:relative;
    height:35px;
    width:100%;
    right:20%;
    background-size: contain;
    background-repeat: no-repeat;
    @media (max-width: 1300px) {
        height:25px;
    }
    @media (max-width: 1000px) {
        height:18px;
    }
`

const InsideWrapper = styled.div`
    position:relative;
    width:100%;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    padding:20px 0px;
`

//Card general style

export {Content,
        TitleWrapper,
        TitleLogoImg,
        Title,
        YellowWrapper,
        YellowImg,
        InsideWrapper,
}